export default {"src":"/_next/static/media/book.f90489c3.svg","height":24,"width":24};